import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon/Icon';
import type { NotificationProps } from './Notification.types';
import './notification.scss';

const Notification = ({ iconName, title, text, color, time, viewed, onClick }: NotificationProps) => {
  const [seen, setSeen] = useState(viewed);
  const [open, setOpen] = useState(false);
  const isViewed = seen || viewed ? 'sb-notification--viewed' : '';

  return (
    <div
      className={['sb-notification',
        isViewed].join(' ')}
      data-testid="sb-notification"
    >
      <div className="sb-notification__top">
        <div
          className={`sb-notification__title ${color && 'text-primary-60'}`}
          style={{ color: color ? color : "" }}
          data-testid="sb-notification__title"
        >
          <Icon
            iconName={iconName}
            size={13}
            className="mr-sm"
          />
          {title}
        </div>
        <div className="flex justify-center items-center ml-lg">
          <span
            className="sb-notification__time"
            data-testid="sb-notification__time"
          >
            {time}
          </span>
          <div className={`sb-notification--more ${open && 'sb-notification--open'}`}>
            <Icon
              iconName="more-vertical"
              size={16}
              className="cursor-pointer ml-lg"
              onClick={() => { setOpen(!open) }}
            />
            <span
              className="sb-notification--view"
              data-testid="sb-notification--view"
              onClick={(event) => {
                setSeen(!seen);
                setOpen(!open);
                onClick && onClick(event);
              }}>
              {seen ? 'Marcar como no leída' : 'Marcar como leída'}
            </span>
          </div>
        </div>
      </div>
      <div
        className="sb-notification__content"
        data-testid="sb-notification__content"
      >
        {text}
      </div>
    </div>
  );
};

Notification.propTypes = {
  /**
* IconName
*/
  iconName: PropTypes.string,
  /**
 * Notification title
 */
  title: PropTypes.string,
  /**
 * Notification text
 */
  text: PropTypes.string,
  /**
* Color of notification
*/
  color: PropTypes.string,
  /**
* time?
*/
  time: PropTypes.string,
  /**
* viewed?
*/
  viewed: PropTypes.bool,
  /**
* onClick
*/
  onClick: PropTypes.func,
};

Notification.defaultProps = {
  iconName: "bell",
  title: "Noticia",
  text: "Tu docente Geomar Ventura Gonzales, te ha enviando un mensaje.",
  color: "",
  time: "Hace un momento",
  viewed: false,
  onClick: () => { }
};

export default Notification;